/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Network_Inspector_TruncatedInputs */

const en_mobile_network_inspector_truncated = /** @type {(inputs: Mobile_Network_Inspector_TruncatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`truncated`)
};

const es_mobile_network_inspector_truncated = /** @type {(inputs: Mobile_Network_Inspector_TruncatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`truncado`)
};

/**
* | output |
* | --- |
* | "truncated" |
*
* @param {Mobile_Network_Inspector_TruncatedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_network_inspector_truncated = /** @type {((inputs?: Mobile_Network_Inspector_TruncatedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Network_Inspector_TruncatedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_network_inspector_truncated(inputs)
	return en_mobile_network_inspector_truncated(inputs)
});